import { Component, ViewEncapsulation } from '@angular/core';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';

@Component({
  selector: 'cert-lea-nav-menu',
  templateUrl: './lea-nav-menu.component.html',
  styles: ``,
  standalone: false,
})
export class LeaNavMenuComponent {
  vouchersEnabled$ = this.featureManager.isFeatureEnabled('vouchers');

  constructor(private readonly featureManager: FeatureManagementService) {}
}
